/*!
 * LOVFEN · ds.js — theme interactions for ds.2026.10.23改良版
 * Vanilla JS, no dependencies, ~9KB. Load with `defer`.
 *
 * Hooks (all optional; nothing runs if the markup is absent):
 *   [data-ds-atc]           add-to-cart form  (Shopify /cart/add.js)
 *   [data-ds-drawer]        cart drawer root
 *   [data-ds-open-cart]     opens the drawer
 *   [data-ds-product]       PDP root, holds variant JSON
 *   [data-ds-variant-id]    variant chip
 *   [data-ds-qty]           quantity stepper
 *   [data-ds-sticky]        mobile sticky add-to-cart bar
 *   [data-ds-acc]           accordion
 *   [data-ds-gallery]       gallery + dots + thumbs
 *   [data-ds-threshold]     free-shipping threshold in cents (default 5000)
 */
(function () {
  'use strict';

  var DS = window.DS || {};
  window.DS = DS;

  var cfg = window.DS_CONFIG || {};
  var FREE_SHIPPING = parseInt(cfg.freeShipping || 5000, 10);
  var MONEY_FORMAT = cfg.moneyFormat || '${{amount}}';

  /* ---------------------------------------------------------- utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }

  function money(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY_FORMAT
      .replace(/\{\{\s*amount\s*\}\}/, withComma + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma.replace(',', ' ') + ',' + parts[1]);
  }

  function unitPrice(cents, count) {
    if (!count || count < 2) return '';
    var tenths = Math.round((cents * 10) / count); // tenths of a cent, per unit
    if (tenths >= 1000) {
      var dollars = Math.floor(tenths / 1000);
      var rem = Math.round((tenths % 1000) / 10);
      if (rem === 100) { dollars += 1; rem = 0; }
      return '$' + dollars + '.' + (rem < 10 ? '0' + rem : rem);
    }
    var c = tenths / 10;
    return (c % 1 === 0 ? c.toFixed(0) : c.toFixed(1)) + '\u00A2';
  }

  function unitSuffix(count) {
    return count && count > 1 ? ' ea' : '';
  }

  function countFromTitle(title) {
    if (!title) return 0;
    var m = String(title).replace(/,/g, '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }

  function debounce(fn, wait) {
    var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, wait); };
  }

  /* ---------------------------------------------------------- toast */
  var toastEl, toastTimer;
  DS.toast = function (message, kind) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ds-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.className = 'ds-toast is-on' + (kind === 'error' ? ' is-error' : '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.className = 'ds-toast' + (kind === 'error' ? ' is-error' : ''); }, 3200);
  };

  /* ---------------------------------------------------------- cart */
  var cartCache = null;

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartCache = cart; return cart; });
  }

  function cartCount(n) {
    $$('[data-ds-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  function renderDrawer(cart) {
    var root = $('[data-ds-drawer]');
    if (!root) return;

    var head = $('[data-ds-drawer-count]', root);
    if (head) head.textContent = cart.item_count;

    var items = $('[data-ds-drawer-items]', root);
    var summary = $('[data-ds-drawer-summary]', root);
    var progress = $('[data-ds-progress]', root);
    var empty = $('[data-ds-drawer-empty]', root);

    if (!items) return;
    items.innerHTML = '';

    if (cart.item_count === 0) {
      if (empty) empty.hidden = false;
      if (summary) summary.hidden = true;
      if (progress) progress.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (summary) summary.hidden = false;
    if (progress) progress.hidden = false;

    cart.items.forEach(function (item, index) {
      var count = countFromTitle(item.variant_title || '') || countFromTitle(item.title || '');
      var unit = count ? unitPrice(item.price, count) : '';
      var row = document.createElement('div');
      row.className = 'ds-li';
      row.setAttribute('data-ds-line', index);
      row.innerHTML =
        '<a class="ds-li__media" href="' + item.url + '">' +
          '<img src="' + (item.image || '') + '" alt="" width="64" height="64" loading="lazy">' +
        '</a>' +
        '<div class="ds-li__body">' +
          '<a class="ds-li__title" href="' + item.url + '">' + item.product_title + '</a>' +
          '<div class="ds-li__variant">' + (item.variant_title || '') + (unit ? ' \u00B7 ' + unit + ' each' : '') + '</div>' +
          '<div class="ds-li__qty">' +
            '<button type="button" data-ds-change="-1" aria-label="Decrease quantity">\u2212</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-ds-change="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="ds-li__price">' + money(item.final_line_price) + '</div>';
      items.appendChild(row);
    });

    var sub = $('[data-ds-subtotal]', root);
    if (sub) sub.textContent = money(cart.total_price);

    var total = $('[data-ds-total]', root);
    if (total) total.textContent = money(cart.total_price);

    var checkout = $('[data-ds-checkout]', root);
    if (checkout) checkout.textContent = 'Checkout \u2014 ' + money(cart.total_price);

    if (progress) renderProgress(cart.total_price);
  }

  function renderProgress(subtotal) {
    var progress = $('[data-ds-progress]');
    if (!progress) return;
    var threshold = parseInt($('[data-ds-drawer]').getAttribute('data-ds-threshold') || FREE_SHIPPING, 10);
    var bar = $('.ds-progress__bar i', progress);
    var label = $('[data-ds-progress-text]', progress);
    var remaining = Math.max(0, threshold - subtotal);
    var pct = Math.min(100, Math.round((subtotal / threshold) * 100));
    if (bar) bar.style.width = pct + '%';
    if (remaining === 0) {
      progress.classList.add('is-done');
      if (label) label.innerHTML = 'Free shipping unlocked \u2014 nice.';
    } else {
      progress.classList.remove('is-done');
      if (label) label.innerHTML = 'You\u2019re <b>' + money(remaining) + '</b> away from free shipping';
    }
  }

  /* ---------------------------------------------------------- drawer open/close */
  var lastFocus = null;
  function openDrawer() {
    var drawer = $('[data-ds-drawer]');
    var overlay = $('[data-ds-overlay]');
    if (!drawer) return;
    lastFocus = document.activeElement;
    getCart().then(renderDrawer).catch(function () {});
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var close = $('[data-ds-close-cart]', drawer);
    if (close) close.focus();
    document.dispatchEvent(new CustomEvent('ds:drawer:open'));
  }
  function closeDrawer() {
    var drawer = $('[data-ds-drawer]');
    var overlay = $('[data-ds-overlay]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  DS.openDrawer = openDrawer;
  DS.closeDrawer = closeDrawer;

  /* ---------------------------------------------------------- add to cart */
  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.innerHTML = 'Adding\u2026'; }

    var data = new FormData(form);
    // never submit the visual quantity field twice
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
        return getCart();
      })
      .then(function (cart) {
        cartCount(cart.item_count);
        renderDrawer(cart);
        openDrawer();
        DS.toast('Added to cart');
        return cart;
      })
      .catch(function (err) {
        DS.toast(err.message || 'Could not add to cart', 'error');
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = original; }
      });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line + 1, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCount(cart.item_count);
        renderDrawer(cart);
        return cart;
      })
      .catch(function () { DS.toast('Could not update cart', 'error'); });
  }

  /* ---------------------------------------------------------- PDP variants */
  function initProduct() {
    var root = $('[data-ds-product]');
    if (!root) return;

    var dataEl = $('[data-ds-variants]', root);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = $('[data-ds-atc]', root);
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var priceEl = $('[data-ds-price]', root);
    var unitEl = $('[data-ds-unit]', root);
    var unitWrap = $('[data-ds-unit-wrap]', root);
    var atcLabel = $('[data-ds-atc-label]', root);
    var stockEl = $('[data-ds-stock]', root);
    var stickyPrice = $('[data-ds-sticky-price]', root);
    var stickyUnit = $('[data-ds-sticky-unit]', root);

    function paint(variant) {
      if (!variant) return;
      var count = countFromTitle(variant.title);
      var unit = count > 1 ? unitPrice(variant.price, count) : '';
      var price = money(variant.price);

      if (priceEl) priceEl.textContent = price;
      if (unitEl && unitWrap) {
        unitEl.textContent = unit ? unit + unitSuffix(count) : '';
        unitWrap.hidden = !unit;
      }
      if (stickyPrice) stickyPrice.textContent = price;
      if (stickyUnit) stickyUnit.textContent = count > 1 ? variant.title + ' \u00B7 ' + unit + ' ea' : variant.title;
      if (atcLabel) atcLabel.textContent = 'Add to cart \u2014 ' + price;
      if (idInput) idInput.value = variant.id;

      if (stockEl) {
        stockEl.classList.remove('is-low', 'is-out');
        if (!variant.available) { stockEl.textContent = 'Sold out'; stockEl.classList.add('is-out'); }
        else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 10) { stockEl.textContent = 'Only ' + variant.inventory_quantity + ' left'; stockEl.classList.add('is-low'); }
        else { stockEl.textContent = 'In stock \u00B7 ships in 5\u20138 business days'; }
      }

      $$('[data-ds-variant-id]', root).forEach(function (chip) {
        var selected = String(chip.getAttribute('data-ds-variant-id')) === String(variant.id);
        chip.classList.toggle('is-selected', selected);
        chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (form) form.setAttribute('data-variant-available', variant.available ? '1' : '0');
      $$('[data-ds-submit]', root).forEach(function (b) { b.disabled = !variant.available; if (!variant.available) b.textContent = 'Sold out'; });

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id)) return variants[i]; }
      return null;
    }

    $$('[data-ds-variant-id]', root).forEach(function (chip) {
      on(chip, 'click', function () {
        var v = findVariant(chip.getAttribute('data-ds-variant-id'));
        if (v) paint(v);
      });
    });

    var params = new URLSearchParams(window.location.search);
    var initial = params.get('variant');
    var active = (initial && findVariant(initial)) || findVariant(idInput && idInput.value) || variants[0];
    if (active) paint(active);

    on(document, 'ds:variant:change', function (e) {
      if (e.detail && e.detail.variant) paint(e.detail.variant);
    });
  }

  /* ---------------------------------------------------------- qty steppers */
  function initQty() {
    $$('[data-ds-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      $$('button', wrap).forEach(function (btn) {
        on(btn, 'click', function () {
          var step = parseInt(btn.getAttribute('data-step') || '1', 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var max = parseInt(input.getAttribute('max') || '999', 10);
          var next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 1) + step));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------------------------------------------------------- sticky ATC */
  function initSticky() {
    var bar = $('[data-ds-sticky]');
    if (!bar) return;
    var anchor = $('[data-ds-sticky-anchor]');
    if (!anchor || !('IntersectionObserver' in window)) { bar.hidden = false; return; }

    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    anchor.appendChild(sentinel);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', visible);
        bar.hidden = !visible;
        document.body.classList.toggle('ds-has-sticky', visible);
      });
    }, { threshold: 0 });
    io.observe(sentinel);
  }

  /* ---------------------------------------------------------- accordion */
  function initAccordion() {
    $$('[data-ds-acc]').forEach(function (acc) {
      var single = acc.getAttribute('data-ds-acc') === 'single';
      $$('.ds-accordion__trigger', acc).forEach(function (btn) {
        var item = btn.closest('.ds-accordion__item');
        var panel = item ? item.querySelector('.ds-accordion__panel') : null;
        if (panel) { panel.id = panel.id || 'ds-panel-' + Math.random().toString(36).slice(2, 8); btn.setAttribute('aria-controls', panel.id); }
        btn.setAttribute('aria-expanded', item && item.classList.contains('is-open') ? 'true' : 'false');
        on(btn, 'click', function () {
          var open = item.classList.contains('is-open');
          if (single) {
            $$('.ds-accordion__item.is-open', acc).forEach(function (other) {
              other.classList.remove('is-open');
              var t = other.querySelector('.ds-accordion__trigger');
              if (t) t.setAttribute('aria-expanded', 'false');
            });
          }
          item.classList.toggle('is-open', !open);
          btn.setAttribute('aria-expanded', !open ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------------------------------------------------------- gallery */
  function initGallery() {
    $$('[data-ds-gallery]').forEach(function (gal) {
      var track = $('.ds-gallery__track', gal);
      if (!track) return;
      var dots = $$('[data-ds-dot]', gal);
      var thumbs = $$('[data-ds-thumb]', gal);
      var slides = $$('.ds-gallery__slide', gal);

      function goTo(index) {
        var slide = slides[index];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      dots.forEach(function (dot, i) { on(dot, 'click', function () { goTo(i); }); });
      thumbs.forEach(function (thumb, i) { on(thumb, 'click', function () { goTo(i); }); });

      on(track, 'scroll', debounce(function () {
        var w = track.clientWidth || 1;
        var index = Math.round(track.scrollLeft / w);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); d.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      }, 80), { passive: true });
    });
  }

  /* ---------------------------------------------------------- boot */
  function boot() {
    document.body.classList.add('ds-theme');
    if (document.querySelector('.ds-mobile-nav')) document.body.classList.add('ds-has-nav');

    cartCount(0);
    getCart().then(function (cart) { cartCount(cart.item_count); renderDrawer(cart); }).catch(function () {});

    $$('form[data-ds-atc], form.ds-buy__form').forEach(function (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        var avail = form.getAttribute('data-variant-available');
        if (avail === '0' || avail === 'false') return;
        addToCart(form);
      });
    });

    $$('[data-ds-open-cart]').forEach(function (el) {
      on(el, 'click', function (e) { e.preventDefault(); openDrawer(); });
    });
    $$('[data-ds-close-cart], [data-ds-overlay]').forEach(function (el) { on(el, 'click', closeDrawer); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-ds-change]');
      if (!btn) return;
      var row = btn.closest('[data-ds-line]');
      if (!row) return;
      var line = parseInt(row.getAttribute('data-ds-line'), 10);
      var span = row.querySelector('.ds-li__qty span');
      var current = span ? parseInt(span.textContent, 10) : 1;
      changeLine(line, Math.max(0, current + parseInt(btn.getAttribute('data-ds-change'), 10)));
    });

    initProduct();
    initQty();
    initSticky();
    initAccordion();
    initGallery();

    // Sticky bar: add to cart uses the same product form
    var stickyBtn = $('[data-ds-sticky] [data-ds-sticky-atc]');
    on(stickyBtn, 'click', function () {
      var form = $('form[data-ds-atc]');
      if (!form) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
